import { Button, ProgressBar } from '@unmind/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { tracking } from 'App/Tracking';
import { changeStep } from 'Book/pages/Service/lib';
import { IStep } from '../Form/types';
import { Wrapper } from './Footer.styles';

interface FooterProps {
  dispatch: IStep['dispatch'];
  step: IStep['step'];
  forwardCTA: {
    label?: string;
    disabled?: boolean;
    validate(e: React.MouseEvent<HTMLButtonElement>): void;
  };
}

export const Footer = ({ step, dispatch, forwardCTA }: FooterProps) => {
  const { t } = useTranslation('book', {
    keyPrefix: 'service.form',
  });

  const totalSteps = 4;
  const progress = Math.round((step / totalSteps) * 100);

  return (
    <Wrapper className="footer">
      <ProgressBar
        progress={progress}
        label={t('progress.label', { step, totalSteps })}
      />
      <ul className="ctas">
        <li>
          <Button
            label={t('ctas.back')}
            onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
              e.preventDefault();
              e.stopPropagation();

              changeStep({ step, direction: 'back', dispatch });
              tracking.track('book_eap_form_button_clicked', {
                step,
                direction: 'back',
              });
            }}
            variant="secondary"
          />
        </li>
        <li>
          <Button
            type="submit"
            label={forwardCTA.label ?? t('ctas.next')}
            onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
              e.preventDefault();
              e.stopPropagation();

              forwardCTA.validate(e);
              tracking.track('book_eap_form_button_clicked', {
                step,
                direction: 'forward',
              });
            }}
            variant="primary"
            disabled={!!forwardCTA.disabled}
          />
        </li>
      </ul>
    </Wrapper>
  );
};
